import { Component, AfterViewInit } from '@angular/core';

import { BeesHeaderComponent } from "../bees-header/bees-header.component";
import { BeesFooterComponent } from "../bees-footer/bees-footer.component";

declare var $: any;

import 'owl.carousel';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { RouterLink } from "@angular/router";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

@Component({
  selector: 'app-page-home',
  standalone: true,

  imports: [
    BeesHeaderComponent,
    BeesFooterComponent,
    RouterLink
],

  templateUrl: './page-home.component.html',
  styleUrl: './page-home.component.scss'
})

export class PageHomeComponent implements AfterViewInit {

  ngAfterViewInit(): void {

    setTimeout(() => {

      // =========================
      // MAIN SWIPER SLIDER
      // =========================

      new Swiper('.thm-swiper__slider', {

        slidesPerView: 1,

        loop: true,

        effect: 'fade',

        autoplay: {
          delay: 5000
        },

        pagination: {
          el: '#main-slider-pagination',
          clickable: true
        },

        navigation: {
          nextEl: '#main-slider__swiper-button-next',
          prevEl: '#main-slider__swiper-button-prev'
        }

      });

      // =========================
      // SERVICES SLIDER
      // =========================

      $('.services-two__carousel').owlCarousel({

        loop: true,

        margin: 30,

        nav: true,

        dots: false,

        autoplay: true,

        autoplayTimeout: 5000,

        smartSpeed: 1000,

        responsive: {

          0: {
            items: 1
          },

          768: {
            items: 2
          },

          1200: {
            items: 3
          }

        }

      });

      // =========================
      // PROJECT SLIDER
      // =========================

      $('.project-two__carousel').owlCarousel({

        loop: true,

        margin: 30,

        nav: true,

        dots: false,

        autoplay: true,

        autoplayTimeout: 5000,

        smartSpeed: 1000,

        responsive: {

          0: {
            items: 1
          },

          768: {
            items: 2
          },

          1200: {
            items: 4
          }

        }

      });

      // =========================
      // TESTIMONIAL SLIDER
      // =========================

      $('.testimonial-two__carousel').owlCarousel({

        loop: true,

        margin: 30,

        nav: true,

        dots: false,

        autoplay: true,

        autoplayTimeout: 5000,

        smartSpeed: 1000,

        responsive: {

          0: {
            items: 1
          },

          768: {
            items: 2
          },

          1200: {
            items: 3
          }

        }

      });

      // =========================
      // TEAM SLIDER
      // =========================

      $('.team-two__carousel').owlCarousel({

        loop: true,

        margin: 30,

        nav: true,

        dots: false,

        autoplay: true,

        autoplayTimeout: 5000,

        smartSpeed: 1000,

        responsive: {

          0: {
            items: 1
          },

          768: {
            items: 2
          },

          1200: {
            items: 4
          }

        }

      });

    }, 1000);

    $('.brand-one__carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 2000,
      smartSpeed: 1000,
      responsive: {
        0: {
          items: 2
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    });

  }

  

}